/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type StorefrontCreatorsUrls_featuredCreatorsUrls = {
    readonly creatorsUrls: ReadonlyArray<{
        readonly displayName: string | null;
        readonly linkData: {
            readonly " $fragmentRefs": FragmentRefs<"SeoLink_linkData">;
        };
    } | null> | null;
    readonly " $refType": "StorefrontCreatorsUrls_featuredCreatorsUrls";
};
export type StorefrontCreatorsUrls_featuredCreatorsUrls$data = StorefrontCreatorsUrls_featuredCreatorsUrls;
export type StorefrontCreatorsUrls_featuredCreatorsUrls$key = {
    readonly " $data"?: StorefrontCreatorsUrls_featuredCreatorsUrls$data;
    readonly " $fragmentRefs": FragmentRefs<"StorefrontCreatorsUrls_featuredCreatorsUrls">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "StorefrontCreatorsUrls_featuredCreatorsUrls",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorsUrls",
      "kind": "LinkedField",
      "name": "creatorsUrls",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "linkData",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeoLink_linkData"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DealerStorefrontQueryConnection",
  "abstractKey": null
};
(node as any).hash = 'a244b5a2194b0fcd1823940861b19b43';
export default node;
